import { cva } from 'class-variance-authority';

export const tabsListVariants = cva('flex items-start justify-start', {
  variants: {
    variant: {
      default: '',
      primary:
        'flex flex-wrap items-start justify-start gap-0 rounded-none bg-transparent p-0 text-muted-foreground',
      secondary:
        'inline-flex w-full max-w-full flex-nowrap items-start justify-start gap-0 rounded-none border-0 bg-transparent p-0',
      header: 'flex flex-wrap items-start justify-end gap-0 rounded-none bg-transparent p-0',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const tabsTriggerVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        primary:
          "rounded-none border-b border-border px-4 pb-2 pt-1 font-sans text-lg font-medium tracking-[0.025em] text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:bg-muted data-[state='active']:border-primary data-[state='active']:text-foreground",
        secondary:
          "h-11 shrink-0 whitespace-nowrap rounded-none border border-l-0 border-[hsl(var(--brand-accent))] bg-background px-4 text-sm font-medium text-[hsl(var(--brand-accent))] transition-colors first:ml-0 first:border-l data-[state='active']:bg-[hsl(var(--brand-accent))] data-[state='active']:text-[hsl(var(--brand-accent-foreground))] data-[state='inactive']:hover:bg-primary/10 data-[state='inactive']:hover:text-primary data-[state='inactive']:focus-visible:bg-primary/10",
        header:
          "rounded-none border-b-[2px] border-b-transparent px-4 py-4 font-heading text-[15px] font-semibold leading-5 tracking-normal text-foreground/80 hover:text-foreground data-[state='active']:border-b-[hsl(var(--brand-accent))] data-[state='active']:text-foreground",
      },
      size: {
        default: '',
        compact: 'px-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
